import Agents from "../../../components/common/Agents";
import Brands from "../../../components/common/Brands";
import Testimonials2 from "../../../components/common/Testimonials2";
import Footer1 from "../../../components/footer/Footer1";
import Header1 from "../../../components/headers/Header1";
import Benefit from "../../../components/homes/home-2/Benefit";
import Banner from "../../../components/common/Banner";
import About from "../../../components/otherPages/About";
import Slider1 from "../../../components/property-details/Slider1";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BaseURL } from "../../../APIs/APIUrls";

import MetaComponent from "../../../components/common/MetaComponent";
import { GetAllPageBannerforWeb } from "../../../APIs/APIHelperforWeb";

export default function AboutUsPage() {
  const { pathname } = useLocation();

  const [MetaTitle, setMetaTitle] = React.useState("About Us || AskMeRealty - Real Estate Services");
  const [MetaDescription, setMetaDescription] = React.useState("AskMeRealty - Learn more about AskMeRealty, our mission, vision, and the team dedicated to providing exceptional real estate services. Discover how we can help you with your property needs.");
  const [MetaKeywords, setMetaKeywords] = React.useState("About Us, AskMeRealty, Real Estate Services, Property Buying, Property Selling, Property Renting, Property Management, Real Estate Solutions");
  const [MetaImage, setMetaImage] = React.useState("");

  const normalizePath = (value = "") => {
    const rawValue = String(value || "").trim();
    if (!rawValue) return "/";

    let pathValue = rawValue;
    try {
      if (/^https?:\/\//i.test(rawValue)) {
        pathValue = new URL(rawValue).pathname;
      }
    } catch (error) {
      pathValue = rawValue;
    }

    const withoutQueryOrHash = decodeURIComponent(pathValue)
      .split(/[?#]/)[0]
      .trim()
      .toLowerCase();
    if (!withoutQueryOrHash) return "/";

    const withLeadingSlash = withoutQueryOrHash.startsWith("/")
      ? withoutQueryOrHash
      : `/${withoutQueryOrHash}`;

    const compactSlashes = withLeadingSlash.replace(/\/+/g, "/");
    return compactSlashes.length > 1
      ? compactSlashes.replace(/\/+$/, "")
      : compactSlashes;
  };

  const getPageNameFromPath = (path) => {
    const cleanPath = normalizePath(path);
    const segment = cleanPath.split("/").filter(Boolean).pop() || "page";
    return segment
      .replace(/[-_]+/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const getBestBannerMatch = (rows, activePath) => {
    if (!Array.isArray(rows) || rows.length === 0) return null;

    const scoredMatches = rows
      .map((item) => {
        const bannerPath = normalizePath(item?.PageURL);
        if (!bannerPath || bannerPath === "/") {
          return null;
        }

        let score = 0;
        if (bannerPath === activePath) {
          score = 4;
        } else if (activePath.startsWith(`${bannerPath}/`)) {
          score = 3;
        } else if (bannerPath.startsWith(`${activePath}/`)) {
          score = 2;
        } else {
          const activeSlug = activePath.split("/").filter(Boolean).pop();
          const bannerSlug = bannerPath.split("/").filter(Boolean).pop();
          if (activeSlug && bannerSlug && activeSlug === bannerSlug) {
            score = 1;
          }
        }

        if (!score) return null;
        return { item, score, pathLength: bannerPath.length };
      })
      .filter(Boolean)
      .sort((a, b) => b.score - a.score || b.pathLength - a.pathLength);

    return scoredMatches[0]?.item || null;
  };

  useEffect(() => {
    const fetchPageBanner = async () => {
      const rows = await GetAllPageBannerforWeb();
      const activePath = normalizePath(pathname);
      const matchedBanner = getBestBannerMatch(rows, activePath);

      setMetaTitle(
        matchedBanner?.MetaTitle || `${getPageNameFromPath(activePath)} | AskMeRealty - Real Estate Services`
      );
      setMetaDescription(
        matchedBanner?.MetaDescription ||
        "AskMeRealty - Learn more about AskMeRealty, our mission, vision, and the team dedicated to providing exceptional real estate services. Discover how we can help you with your property needs."
      );
      setMetaKeywords(
        matchedBanner?.MetaKeyword ||
        "About Us, AskMeRealty, Real Estate Services, Property Buying, Property Selling, Property Renting, Property Management, Real Estate Solutions"
      );

      setMetaImage(matchedBanner?.Image ? BaseURL + matchedBanner.Image : "");
    };

    fetchPageBanner();
  }, [pathname]);


  const metadata = {
    title: MetaTitle,
    description: MetaDescription,
    keywords: MetaKeywords,
    url: window.location.href,
    siteName: "AskMeRealty",
    canonical: window.location.href,
    image: MetaImage,
  };



  return (
    <>
      <MetaComponent meta={metadata} />
      <Header1 />
      <About />
      {/* <Slider1 /> */}
      {/* <Agents /> */}
      {/* <Brands /> */}
      {/* <Benefit /> */}
      <Testimonials2 />
      <Banner />
      <Footer1 />
    </>
  );
}
